import { commonEnv } from "./environment.common";

export const environment = {
  production: true,
  env: "prod",
  clientFolder: "TofesMashkantaClient",
  GAKey: "UA-71783710-7",//SC prod
  apiUri: 'https://sc.mizrahi-tefahot.co.il/TofesMashkantaWebAPI/api',
  route: 'TofesMashkantaWebAPI/api',
  chatUrl: 'https://vc.mizrahi-tefahot.co.il/floatingChatNGv2.aspx?profile={0}&lang=he&t={1}&url={2}7refer={3}&title={4}',
  common: { ...commonEnv }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts